// Search Results pagination emits a namespaced `start` for far pages but the widget reads plain `start`; normalize it.
(function () {
    var RE = /_SearchResultsPortlet_INSTANCE_[a-z0-9]+_start=(\d+)/i;
    function clean(search, n) {
        var p = new URLSearchParams(search), keys = [];
        p.forEach(function (v, k) { keys.push(k); });
        keys.forEach(function (k) { if (/_start$/.test(k) && k.indexOf('SearchResultsPortlet') !== -1) p.delete(k); });
        p.set('start', n);
        return p.toString();
    }
    function fixUrlNow() {
        var m = location.search.match(RE);
        if (m) { location.replace(location.pathname + '?' + clean(location.search, m[1])); return true; }
        return false;
    }
    if (fixUrlNow()) return;
    // Rewrite pagination links before navigation to avoid a redirect flash.
    document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href]');
        if (!a) return;
        var mm = (a.getAttribute('href') || '').match(RE);
        if (!mm) return;
        var u = new URL(a.href, location.origin);
        a.setAttribute('href', u.pathname + '?' + clean(u.search, mm[1]));
    }, true);
    // Backstop for Liferay SPA navigation landing on the namespaced URL.
    if (window.Liferay && Liferay.on) { Liferay.on('endNavigate', fixUrlNow); }
})();

// YouTube consent facade (GDPR): replace YT iframes with a placeholder until personalization consent.
(function () {
    function hasConsent() {
        return document.cookie.indexOf('CONSENT_TYPE_PERSONALIZATION=true') !== -1;
    }
    if (hasConsent()) return;

    var lang = (document.documentElement.lang || 'ca').substring(0, 2);
    var label = {
        ca: 'Accepta les cookies per veure aquest contingut',
        es: 'Acepta las cookies para ver este contenido',
        en: 'Accept cookies to view this content'
    }[lang] || 'Accepta les cookies per veure aquest contingut';
    var linkText = {
        ca: 'Canvia la configuració de cookies',
        es: 'Cambiar la configuración de cookies',
        en: 'Change cookie settings'
    }[lang] || 'Canvia la configuració de cookies';

    function buildPlaceholder() {
        var ph = document.createElement('div');
        ph.className = 'sp__video-cookie-blocked';
        var t = document.createElement('span');
        t.className = 'sp__video-cookie-blocked--text';
        t.textContent = label;
        ph.appendChild(t);
        var link = document.createElement('a');
        link.className = 'sp__video-cookie-link';
        link.textContent = linkText;
        link.href = '#';
        link.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            ['CONSENT_TYPE_NECESSARY', 'CONSENT_TYPE_FUNCTIONAL', 'CONSENT_TYPE_PERFORMANCE', 'CONSENT_TYPE_PERSONALIZATION', 'USER_CONSENT_CONFIGURED'].forEach(function (n) {
                document.cookie = n + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
            });
            window.location.reload();
        });
        ph.appendChild(link);
        return ph;
    }

    // Detached originals, kept so they can be restored on consent without reload.
    var blocked = [];
    // Set when a video's script was gated → no iframe to replace.
    var containerBlocked = false;

    function block(iframe) {
        // Also remove the fragment's spinner/mask (never hidden since the player won't init).
        var wrap = iframe.closest('.video') || iframe.parentNode;
        var ph = buildPlaceholder();
        if (iframe.parentNode) {
            iframe.parentNode.replaceChild(ph, iframe);
            blocked.push({ ph: ph, iframe: iframe });
        }
        if (wrap && wrap.querySelectorAll) {
            wrap.querySelectorAll('.loading-animation, .video-mask').forEach(function (el) {
                el.remove();
            });
        }
    }

    // Gated player script → no iframe: show the placeholder and drop the spinner.
    function blockContainer(wrap) {
        if (!wrap || wrap.querySelector('.sp__video-cookie-blocked') || wrap.querySelector('iframe')) return;
        var target = wrap.querySelector('.video-container') || wrap;
        target.appendChild(buildPlaceholder());
        containerBlocked = true;
        wrap.querySelectorAll('.loading-animation, .video-mask').forEach(function (el) { el.remove(); });
    }

    // Responsive 16:9 sizing via CSS (the fragment's own resize() never runs on dynamic restore).
    function sizeVideo(iframe) {
        iframe.style.width = '100%';
        iframe.style.aspectRatio = '16 / 9';
        iframe.style.height = 'auto';
    }

    // On consent, re-insert + size the original iframes — no page reload.
    function restoreAll() {
        blocked.forEach(function (b) {
            if (b.ph.parentNode) {
                b.ph.parentNode.replaceChild(b.iframe, b.ph);
                sizeVideo(b.iframe);
            }
        });
        blocked = [];
    }

    function sweep(root) {
        if (!root || !root.querySelectorAll) return;
        root.querySelectorAll('iframe[src*="youtube"]').forEach(block);
        // Clean orphan spinner/mask inside an already-blocked video wrapper.
        root.querySelectorAll('.video').forEach(function (wrap) {
            if (wrap.querySelector('.sp__video-cookie-blocked')) {
                wrap.querySelectorAll('.loading-animation, .video-mask').forEach(function (el) {
                    el.remove();
                });
            } else if (!wrap.querySelector('iframe')) {
                // No iframe (script gated) → placeholder here too.
                blockContainer(wrap);
            }
        });
    }

    var observer = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
            m.addedNodes.forEach(function (n) {
                if (n.nodeType !== 1) return;
                if (n.tagName === 'IFRAME' && n.src && n.src.indexOf('youtube') !== -1) {
                    block(n);
                } else {
                    sweep(n);
                }
            });
        });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    sweep(document);
    document.addEventListener('DOMContentLoaded', function () { sweep(document); });

    // When personalization consent is granted, stop blocking and restore videos.
    var consentWatch = setInterval(function () {
        if (hasConsent()) {
            clearInterval(consentWatch);
            observer.disconnect();
            // Gated-script video: reload so the player can initialise.
            if (containerBlocked) { window.location.reload(); return; }
            restoreAll();
        }
    }, 600);
})();

/*
 * This function gets loaded when all the HTML, not including the portlets, is
 * loaded.
 */
AUI().ready(function () {

    const pdfButtons = document.querySelectorAll(".sp__btn--primary");
    
    if (pdfButtons.length > 0) {
        pdfButtons.forEach(btn => {
    
            if (btn.textContent.includes("PDF")) {
                btn.classList.add("has-pdf");
            }
        })
    }
});

/*
 * This function gets loaded after each and every portlet on the page.
 *
 * portletId: the current portlet's id
 * node: the Alloy Node object of the current portlet
 */
Liferay.Portlet.ready(function (_portletId, _node) {});

/*
 * This function gets loaded when everything, including the portlets, is on
 * the page.
 */
Liferay.on('allPortletsReady', function () {
    // Cookie consent: transform config modal iframe into tabbed layout
    function transformCookieConfigTabs(iframeDoc) {
        if (iframeDoc.querySelector('.sp-cookie-tabs')) return;

        var allCol12 = iframeDoc.querySelectorAll('.col-12');
        var cookieContainer = null;
        for (var c = 0; c < allCol12.length; c++) {
            if (allCol12[c].querySelector('h2')) { cookieContainer = allCol12[c]; break; }
        }
        if (!cookieContainer) return;

        var headers = cookieContainer.querySelectorAll('.autofit-row-center');
        var descriptions = cookieContainer.querySelectorAll('.autofit-row.mb-3');
        if (headers.length === 0) return;

        var tabsContainer = iframeDoc.createElement('div');
        tabsContainer.className = 'sp-cookie-tabs';
        var panelsContainer = iframeDoc.createElement('div');
        panelsContainer.className = 'sp-cookie-panels';

        headers.forEach(function (header, i) {
            var h2 = header.querySelector('h2');
            var toggle = header.querySelector('.toggle-switch');
            var activeLabel = header.querySelector('.text-primary');
            var desc = descriptions[i] ? descriptions[i].querySelector('p') : null;

            var tab = iframeDoc.createElement('span');
            tab.className = 'sp-cookie-tab' + (i === 0 ? ' selected' : '');
            tab.textContent = h2 ? h2.textContent.trim() : 'Cookie ' + (i + 1);
            tab.dataset.index = i;
            tabsContainer.appendChild(tab);

            var panel = iframeDoc.createElement('div');
            panel.className = 'sp-cookie-panel' + (i === 0 ? ' active' : '');
            panel.dataset.index = i;

            if (activeLabel && activeLabel.textContent.trim()) {
                var lbl = iframeDoc.createElement('div');
                lbl.className = 'sp-cookie-active-label';
                lbl.textContent = activeLabel.textContent.trim();
                panel.appendChild(lbl);
            }
            if (toggle) {
                var toggleWrap = iframeDoc.createElement('div');
                toggleWrap.className = 'sp-cookie-toggle';
                toggleWrap.appendChild(toggle);
                panel.appendChild(toggleWrap);
            }
            if (desc) { panel.appendChild(desc.cloneNode(true)); }

            panelsContainer.appendChild(panel);
        });

        tabsContainer.addEventListener('click', function (e) {
            var tab = e.target.closest('.sp-cookie-tab');
            if (!tab) return;
            var idx = tab.dataset.index;
            tabsContainer.querySelectorAll('.sp-cookie-tab').forEach(function (t) { t.classList.remove('selected'); });
            panelsContainer.querySelectorAll('.sp-cookie-panel').forEach(function (p) { p.classList.remove('active'); });
            tab.classList.add('selected');
            panelsContainer.querySelector('.sp-cookie-panel[data-index="' + idx + '"]').classList.add('active');
        });

        var style = iframeDoc.createElement('style');
        style.textContent = [
            '.col-12 > .autofit-row { display: none !important; }',
            '.sp-cookie-tabs { display: flex; flex-wrap: wrap; gap: 0; border-bottom: 1px solid #e5e5e5; margin-bottom: 1rem; padding: 0; }',
            '.sp-cookie-tab { padding: .5rem .75rem; cursor: pointer; font-size: .8125rem; color: #4B4B4B; border-bottom: 2px solid transparent; font-weight: 400; white-space: nowrap; }',
            '.sp-cookie-tab.selected { border-bottom-color: #34855F; font-weight: 700; color: #34855F; }',
            '.sp-cookie-tab:hover { color: #34855F; }',
            '.sp-cookie-panels { padding: 0; }',
            '.sp-cookie-panel { display: none; }',
            '.sp-cookie-panel.active { display: block; }',
            '.sp-cookie-panel p { font-size: 1rem; line-height: 1.5; color: #4B4B4B; margin: 0; }',
            '.sp-cookie-active-label { color: #34855F; font-weight: 600; font-size: 1rem; margin-bottom: .5rem; }',
            '.sp-cookie-toggle { margin-bottom: .5rem; }',
            '.col-12.mb-3 p { font-size: 1rem; color: #707070; line-height: 1.4; }',
            '.container-fluid { padding: 1rem !important; overflow: visible; }',
            'html, body { height: auto; overflow-y: auto; }',
            '.row { margin: 0; }'
        ].join('\n');
        iframeDoc.head.appendChild(style);

        cookieContainer.appendChild(tabsContainer);
        cookieContainer.appendChild(panelsContainer);
    }

    // Watch for the config modal to appear in the DOM (it's created dynamically on click)
    var configObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;
                var modal = node.id === 'cookiesBannerConfiguration' ? node : (node.querySelector && node.querySelector('#cookiesBannerConfiguration'));
                if (!modal) return;

                // Hide cookie banner while config modal is open
                var bannerBehind = document.querySelector('.cookies-banner.cookies-banner-bottom');
                if (bannerBehind) bannerBehind.style.display = 'none';

                // Watch for iframe inside the modal
                var iframeObserver = new MutationObserver(function () {
                    var iframe = modal.querySelector('iframe');
                    if (!iframe) return;
                    iframe.addEventListener('load', function () {
                        try {
                            var iDoc = iframe.contentDocument || iframe.contentWindow.document;
                            if (iDoc) {
                                transformCookieConfigTabs(iDoc);
                                // Hide loading spinners (don't remove — Liferay/React manages DOM)
                                modal.querySelectorAll('.loading-animation').forEach(function(el) { el.style.cssText = 'display:none!important;height:0!important;width:0!important;'; });
                                // Hide close (X) button from modal header
                                modal.querySelectorAll('.modal-header .close, .modal-header .btn-close, .modal-header button[aria-label="Close"], .modal-header button[aria-label="close"], .modal-header button[data-dismiss="modal"]').forEach(function(el) { el.style.cssText = 'display:none!important;'; });
                                modal.classList.add('sp--ready');
                            }
                        } catch(e) {}
                    });
                    // Also try immediately in case iframe already loaded
                    try {
                        var iDoc = iframe.contentDocument || iframe.contentWindow.document;
                        if (iDoc && iDoc.querySelector('h2')) {
                            transformCookieConfigTabs(iDoc);
                            modal.querySelectorAll('.loading-animation').forEach(function(el) { el.style.cssText = 'display:none!important;height:0!important;width:0!important;'; });
                            modal.querySelectorAll('.modal-header .close, .modal-header .btn-close, .modal-header button[aria-label="Close"], .modal-header button[aria-label="close"], .modal-header button[data-dismiss="modal"]').forEach(function(el) { el.style.cssText = 'display:none!important;'; });
                            modal.classList.add('sp--ready');
                        }
                    } catch(e) {}
                });
                iframeObserver.observe(modal, { childList: true, subtree: true });

                // Add YouTube blocking listeners to config modal buttons (Confirm, Accept All, Decline All)
                // Poll cookies after click because Liferay sets them asynchronously
                var modalFooter = modal.querySelector('.modal-footer');
                if (modalFooter) {
                    modalFooter.querySelectorAll('button').forEach(function (btn) {
                        btn.addEventListener('click', function () {
                            var attempts = 0;
                            var maxAttempts = 20;
                            var checkInterval = setInterval(function () {
                                attempts++;
                                if (document.cookie.indexOf('USER_CONSENT_CONFIGURED=true') !== -1) {
                                    clearInterval(checkInterval);
                                    if (shouldBlockYouTube()) {
                                        blockAllYouTubeIframes();
                                    }
                                }
                                if (attempts >= maxAttempts) {
                                    clearInterval(checkInterval);
                                }
                            }, 100);
                        });
                    });
                }
            });
        });
    });
    configObserver.observe(document.body, { childList: true, subtree: true });

    // Reset cookie consent and reload so banner appears again
    function resetCookieConsent() {
        var cookieNames = [
            'CONSENT_TYPE_NECESSARY',
            'CONSENT_TYPE_FUNCTIONAL',
            'CONSENT_TYPE_PERFORMANCE',
            'CONSENT_TYPE_PERSONALIZATION',
            'USER_CONSENT_CONFIGURED'
        ];
        cookieNames.forEach(function (name) {
            document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
        });
        window.location.reload();
    }

    // YouTube blocking
    var label = 'Accept cookies to view this content';
    try { var l = Liferay.Language.get('accept.cookies'); if (l && l !== 'accept.cookies') label = l; } catch(e) {}

    function blockYouTubeIframe(iframe) {
        var placeholder = document.createElement('div');
        placeholder.className = 'sp__video-cookie-blocked';

        var textSpan = document.createElement('span');
        textSpan.className = 'sp__video-cookie-blocked--text';
        textSpan.textContent = label;
        placeholder.appendChild(textSpan);

        var link = document.createElement('a');
        link.className = 'sp__video-cookie-link';
        link.textContent = 'Change cookie settings';
        link.href = '#';
        link.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            resetCookieConsent();
        });
        placeholder.appendChild(link);

        if (iframe && iframe.parentNode) {
            iframe.parentNode.replaceChild(placeholder, iframe);
        }
    }

    function blockAllYouTubeIframes() {
        var ytIframes = document.querySelectorAll('iframe[src*="youtube"]');
        ytIframes.forEach(function (iframe) { blockYouTubeIframe(iframe); });
    }

    function shouldBlockYouTube() {
        // Privacy-first: block unless personalization consent is explicitly granted.
        var hasConsent = document.cookie.indexOf('CONSENT_TYPE_PERSONALIZATION=true') !== -1;
        return !hasConsent;
    }

    // Block immediately if user already rejected personalization
    if (shouldBlockYouTube()) {
        blockAllYouTubeIframes();
    }

    // Watch for when user clicks Decline/Accept on the cookie banner
    // Poll cookies after click because Liferay sets them asynchronously
    var bannerEl = document.querySelector('.cookies-banner.cookies-banner-bottom');
    if (bannerEl) {
        var bannerButtons = bannerEl.querySelectorAll('button');
        bannerButtons.forEach(function (btn) {
            btn.addEventListener('click', function () {
                var attempts = 0;
                var maxAttempts = 20;
                var checkInterval = setInterval(function () {
                    attempts++;
                    if (document.cookie.indexOf('USER_CONSENT_CONFIGURED=true') !== -1) {
                        clearInterval(checkInterval);
                        if (shouldBlockYouTube()) {
                            blockAllYouTubeIframes();
                        }
                    }
                    if (attempts >= maxAttempts) {
                        clearInterval(checkInterval);
                    }
                }, 100);
            });
        });
    }

    // Watch for dynamically added YouTube iframes
    var bodyObserver = new MutationObserver(function (mutations) {
        if (!shouldBlockYouTube()) return;
        mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType !== 1) return;
                if (node.tagName === 'IFRAME' && node.src && node.src.indexOf('youtube') !== -1) {
                    blockYouTubeIframe(node);
                }
                var nested = node.querySelectorAll && node.querySelectorAll('iframe[src*="youtube"]');
                if (nested) { nested.forEach(function (f) { blockYouTubeIframe(f); }); }
            });
        });
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
});

// A11y: give OWL carousel dots and prev/next buttons an aria-label (re-applied on refresh/resize).
Liferay.on('allPortletsReady', function () {
    var lang = (document.documentElement.lang || 'ca').substring(0, 2);
    var t = {
        ca: { slide: 'Diapositiva', prev: 'Anterior', next: 'Següent' },
        es: { slide: 'Diapositiva', prev: 'Anterior', next: 'Siguiente' },
        en: { slide: 'Slide', prev: 'Previous', next: 'Next' }
    }[lang] || { slide: 'Diapositiva', prev: 'Anterior', next: 'Següent' };

    function labelOwlControls() {
        document.querySelectorAll('.owl-carousel').forEach(function (carousel) {
            carousel.querySelectorAll('.owl-dot').forEach(function (dot, i) {
                dot.setAttribute('aria-label', t.slide + ' ' + (i + 1));
            });
            carousel.querySelectorAll('.owl-prev').forEach(function (b) {
                b.setAttribute('aria-label', t.prev);
            });
            carousel.querySelectorAll('.owl-next').forEach(function (b) {
                b.setAttribute('aria-label', t.next);
            });
        });
    }

    labelOwlControls();

    if (window.jQuery) {
        window.jQuery(document).on(
            'initialized.owl.carousel refreshed.owl.carousel',
            '.owl-carousel',
            labelOwlControls
        );
    }
});

// Function that toggles the mobile menu
function toggleMenu(){
    const headerTools = document.querySelector('.sp__header__heading__tools');
    const headerMenu = document.querySelector('.sp__menu');

    if(headerTools.style.display === "none" || headerTools.style.display === ""){
        headerTools.style.display = "flex";   
    }else{
        headerTools.style.display = "none";       
    }

    if(headerMenu.style.display === "none" || headerMenu.style.display === ""){
        headerMenu.style.display = "flex";   
    }else{
        headerMenu.style.display = "none";       
    }   
}

// Expands a menu child in mobile
function toggleChild(el){
    
    const currentChild = el.nextElementSibling;

    el.classList.toggle('open');

    if(currentChild.style.display === "none" || currentChild.style.display === ""){
        currentChild.style.display = "block";   
    }else{
        currentChild.style.display = "none";       
    }
}

// Mobile anchor functionality by id
function anchorMobile(el,parent, event){

    if(window.innerWidth < 992){   
        if(el.classList.contains('active')){
            event.preventDefault();
            parent.classList.toggle('open'); 
        } else{
            parent.classList.remove('open');
        }   
    }    
}

// Mobile anchor functionality by class
function anchorMobileClass(el, parent, event, className) {
    if(window.innerWidth < 992) {
        if(el.classList.contains('active')) {
            event.preventDefault();
            parent.classList.toggle('open');
            return;
        } else {
            parent.classList.remove('open');
        }
    }

    // Scroll to element by class
    var target = document.querySelector('.' + className);
    if(target) {
        target.scrollIntoView();
    }
}

function tabsMobile(el,parent){

    if(window.innerWidth < 992){   
        if(el.classList.contains('active')){            
            parent.classList.toggle('open'); 
        } else{            
            parent.classList.remove('open');            
        }   
    }    
}